import { ThemeMode } from "../../../types";

import type { ThemeColors } from "../../../types";

export const stone = {
  [ThemeMode.LIGHT]: {
    background: [1, 0, 0],
    foreground: [0.147, 0.004, 49.25],
    card: [1, 0, 0],
    "card-foreground": [0.147, 0.004, 49.25],
    popover: [1, 0, 0],
    "popover-foreground": [0.147, 0.004, 49.25],
    primary: [0.216, 0.006, 56.043],
    "primary-foreground": [0.985, 0.001, 106.423],
    secondary: [0.97, 0.001, 106.424],
    "secondary-foreground": [0.216, 0.006, 56.043],
    muted: [0.97, 0.001, 106.424],
    "muted-foreground": [0.553, 0.013, 58.071],
    accent: [0.97, 0.001, 106.424],
    "accent-foreground": [0.216, 0.006, 56.043],
    destructive: [0.577, 0.245, 27.325],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.7999, 0.1816, 151.78],
    "success-foreground": [0.9848, 0, 0],
    border: [0.923, 0.003, 48.717],
    input: [0.923, 0.003, 48.717],
    ring: [0.709, 0.01, 56.259],
    "chart-1": [0.869, 0.005, 56.366],
    "chart-2": [0.553, 0.013, 58.071],
    "chart-3": [0.444, 0.011, 73.639],
    "chart-4": [0.374, 0.01, 67.558],
    "chart-5": [0.268, 0.007, 34.298],
    sidebar: [0.985, 0.001, 106.423],
    "sidebar-foreground": [0.147, 0.004, 49.25],
    "sidebar-primary": [0.216, 0.006, 56.043],
    "sidebar-primary-foreground": [0.985, 0.001, 106.423],
    "sidebar-accent": [0.97, 0.001, 106.424],
    "sidebar-accent-foreground": [0.216, 0.006, 56.043],
    "sidebar-border": [0.923, 0.003, 48.717],
    "sidebar-ring": [0.709, 0.01, 56.259],
  },
  [ThemeMode.DARK]: {
    background: [0.147, 0.004, 49.25],
    foreground: [0.985, 0.001, 106.423],
    card: [0.216, 0.006, 56.043],
    "card-foreground": [0.985, 0.001, 106.423],
    popover: [0.216, 0.006, 56.043],
    "popover-foreground": [0.985, 0.001, 106.423],
    primary: [0.923, 0.003, 48.717],
    "primary-foreground": [0.216, 0.006, 56.043],
    secondary: [0.268, 0.007, 34.298],
    "secondary-foreground": [0.985, 0.001, 106.423],
    muted: [0.268, 0.007, 34.298],
    "muted-foreground": [0.709, 0.01, 56.259],
    accent: [0.268, 0.007, 34.298],
    "accent-foreground": [0.985, 0.001, 106.423],
    destructive: [0.704, 0.191, 22.216],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.627, 0.194, 149.214],
    "success-foreground": [0.985, 0, 0],
    border: [1, 0, 0, 0.1],
    input: [1, 0, 0, 0.15],
    ring: [0.553, 0.013, 58.071],
    "chart-1": [0.869, 0.005, 56.366],
    "chart-2": [0.553, 0.013, 58.071],
    "chart-3": [0.444, 0.011, 73.639],
    "chart-4": [0.374, 0.01, 67.558],
    "chart-5": [0.268, 0.007, 34.298],
    sidebar: [0.216, 0.006, 56.043],
    "sidebar-foreground": [0.985, 0.001, 106.423],
    "sidebar-primary": [0.488, 0.243, 264.376],
    "sidebar-primary-foreground": [0.985, 0.001, 106.423],
    "sidebar-accent": [0.268, 0.007, 34.298],
    "sidebar-accent-foreground": [0.985, 0.001, 106.423],
    "sidebar-border": [1, 0, 0, 0.1],
    "sidebar-ring": [0.553, 0.013, 58.071],
  },
} satisfies ThemeColors;
